export const NAVIGATION = [
    { label: 'Dashboard', icon: 'LayoutDashboard', path: '/dashboard' },
    {
        label: 'Accounting',
        icon: 'BookOpenCheck',
        children: [
            { label: 'Vouchers', path: '/accounting/vouchers', permission: 'voucher:view' },
            { label: 'Ledgers', path: '/accounting/ledgers', permission: 'ledger:view' },
            { label: 'Chart of Accounts', path: '/accounting/chart-of-accounts', permission: 'account:view' },
            { label: 'Day Book', path: '/accounting/day-book', permission: 'report:view' },
            { label: 'Trial Balance', path: '/accounting/trial-balance', permission: 'report:view' },
            { label: 'Profit & Loss', path: '/accounting/profit-and-loss', permission: 'report:view' },
            { label: 'Balance Sheet', path: '/accounting/balance-sheet', permission: 'report:view' },
            { label: 'Cash Flow', path: '/accounting/cash-flow', permission: 'report:view' },
        ],
    },
    {
        label: 'Projects',
        icon: 'Building2',
        children: [
            { label: 'Projects', path: '/projects', permission: 'project:view' },
            { label: 'Towers', path: '/projects/towers', permission: 'project:view' },
            { label: 'Floors', path: '/projects/floors', permission: 'project:view' },
            { label: 'Units', path: '/projects/units', permission: 'unit:view' },
            { label: 'Cost Centres', path: '/projects/cost-centres', permission: 'costing:view' },
            { label: 'Project Costing', path: '/projects/costing', permission: 'costing:view' },
            { label: 'Project WIP', path: '/projects/wip', permission: 'costing:view' },
        ],
    },
    {
        label: 'Receivables',
        icon: 'HandCoins',
        children: [
            { label: 'Customers', path: '/receivables/customers', permission: 'customer:view' },
            { label: 'Bookings', path: '/receivables/bookings', permission: 'booking:view' },
            { label: 'Payment Schedules', path: '/receivables/payment-schedules', permission: 'booking:view' },
            { label: 'Demands', path: '/receivables/demands', permission: 'demand:view' },
            { label: 'Receipts', path: '/receivables/receipts', permission: 'receipt:view' },
            { label: 'Outstanding', path: '/receivables/outstanding', permission: 'report:view' },
        ],
    },
    {
        label: 'Payables',
        icon: 'Truck',
        children: [
            { label: 'Vendors', path: '/payables/vendors', permission: 'vendor:view' },
            { label: 'Contractors', path: '/payables/contractors', permission: 'contractor:view' },
            { label: 'Purchase Orders', path: '/payables/purchase-orders', permission: 'purchase:view' },
            { label: 'Work Orders', path: '/payables/work-orders', permission: 'contractor:view' },
            { label: 'Bills', path: '/payables/bills', permission: 'purchase:view' },
            { label: 'RA Bills', path: '/payables/ra-bills', permission: 'ra_bill:view' },
            { label: 'Payments', path: '/payables/payments', permission: 'voucher:view' },
        ],
    },
    {
        label: 'Inventory',
        icon: 'Boxes',
        children: [
            { label: 'Materials', path: '/inventory/materials', permission: 'inventory:view' },
            { label: 'Stores', path: '/inventory/stores', permission: 'inventory:view' },
            { label: 'Stock', path: '/inventory/stock', permission: 'inventory:view' },
            { label: 'Material Issues', path: '/inventory/issues', permission: 'inventory:view' },
            { label: 'Transfers', path: '/inventory/transfers', permission: 'inventory:view' },
        ],
    },
    {
        label: 'Banking',
        icon: 'Landmark',
        children: [
            { label: 'Bank Accounts', path: '/banking/accounts', permission: 'banking:view' },
            { label: 'Transactions', path: '/banking/transactions', permission: 'banking:view' },
            { label: 'Reconciliation', path: '/banking/reconciliation', permission: 'banking:view' },
        ],
    },
    {
        label: 'Taxes',
        icon: 'ReceiptIndianRupee',
        children: [
            { label: 'GST', path: '/taxes/gst', permission: 'tax:view' },
            { label: 'TDS', path: '/taxes/tds', permission: 'tax:view' },
            { label: 'Tax Reports', path: '/taxes/reports', permission: 'tax:view' },
        ],
    },
    {
        label: 'Finance',
        icon: 'Percent',
        children: [
            { label: 'Loans', path: '/finance/loans', permission: 'loan:view' },
            { label: 'EMI Schedule', path: '/finance/emi', permission: 'loan:view' },
            { label: 'Interest', path: '/finance/interest', permission: 'loan:view' },
        ],
    },
    {
        label: 'Assets',
        icon: 'Warehouse',
        children: [
            { label: 'Fixed Assets', path: '/assets', permission: 'asset:view' },
            { label: 'Depreciation', path: '/assets/depreciation', permission: 'asset:view' },
            { label: 'Asset Register', path: '/assets/register', permission: 'asset:view' },
        ],
    },
    { label: 'Landowners / JDA', icon: 'Handshake', path: '/landowners', permission: 'landowner:view' },
    { label: 'Reports', icon: 'FileBarChart', path: '/reports', permission: 'report:view' },
    { label: 'Documents', icon: 'FolderOpen', path: '/documents', permission: 'document:view' },
    { label: 'Approvals', icon: 'CheckCheck', path: '/approvals', permission: 'approval:view' },
    { label: 'Settings', icon: 'Settings', path: '/settings', permission: 'settings:view' },
    { label: 'Integrations', icon: 'Plug', path: '/integrations', permission: 'integration:view' },
];
//# sourceMappingURL=navigation.js.map